import React from 'react';
import { useState, useEffect } from 'react';


import LandingDesktop from './LandingPageDesktop.js';
import LandingMobile from './LandingPageMobile.js';


const LandingPage = () => {
    const useMediaQuery = (query) => {
        const [matches, setMatches] = useState(() => window.matchMedia(query).matches);
      
        useEffect(() => {
          const media = window.matchMedia(query);
          const listener = () => setMatches(media.matches);
          media.addEventListener('change', listener);
          return () => media.removeEventListener('change', listener);
        }, [query]);
      
        return matches;
      };


const isLargeScreen = useMediaQuery('(min-width: 1024px)');
  
  
  return (
    <div 
      style={{
        maxWidth: '100%',
        height: '100dvh',
        overflow: 'hidden',
        background: 'linear-gradient(to right, #87CEEB, #FFD8A8)',
        color:'black'
    }}
    >
        { isLargeScreen ? 
            <LandingDesktop/>
            :

            <LandingMobile/>

        }


    </div>
  );
};

export default LandingPage;